import { createContext, useContext, useState, ReactNode } from "react";

interface PageTitleContextType {
  pageTitle: string;
  pageSubtitle: string;
  setPageTitle: (title: string, subtitle: string) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export const PageTitleProvider = ({ children }: { children: ReactNode }) => {
  const [pageTitle, setTitle] = useState("");
  const [pageSubtitle, setSubtitle] = useState("");

  const setPageTitle = (title: string, subtitle: string) => {
    setTitle(title);
    setSubtitle(subtitle);
  };

  return (
    <PageTitleContext.Provider value={{ pageTitle, pageSubtitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitleContext = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error("usePageTitleContext must be used within a PageTitleProvider");
  }
  return context;
};
